import { Model } from "pinia-orm";
import AosOutdoorSpace from "./AosOutdoorSpace";
import Zone from "./Zone";
import OtherItem from "./OtherItem";
import Component from "./Component";
import AosSite from "./AosSite";
import Building from "./Building";
import BasiasBasolSisNearbySiteOther from "./BasiasBasolSisNearbySiteOther.js";
import Spreading from "./Spreading";

export default class Marker extends Model {
  static entity = "markers";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      parent_uuid: this.attr(null),
      long: this.attr(null),
      lat: this.attr(null),
      markable_id: this.attr(null),
      markable_type: this.attr(null),
      markable: this.morphTo(
        [
          AosOutdoorSpace,
          Zone,
          OtherItem,
          Component,
          AosSite,
          Building,
          BasiasBasolSisNearbySiteOther,
          Spreading,
        ],
        "markable_id",
        "markable_type",
      ),
      markers: this.hasMany(Marker, "parent_uuid"),
    };
  }
}
